import { render } from "./PersonalDataScreen.vue?vue&type=template&id=568ee724&scoped=true&lang=html"
import script from "./PersonalDataScreen.vue?vue&type=script&lang=js"
export * from "./PersonalDataScreen.vue?vue&type=script&lang=js"

import "./PersonalDataScreen.vue?vue&type=style&index=0&id=568ee724&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_rodi/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568ee724"]])

export default __exports__